import React, { useState, useEffect, useRef, Fragment, CSSProperties } from "react";
import { View, StyleSheet, Text } from 'react-native';
import Modal from "react-modal";

import { FONT } from "../../../value/staticValues";
import { POPUP_TYPE } from "../../../value/type";

import { ReactComponent as CloseButtonImg } from "../../../img/btn-close-white.svg";
import { ReactComponent as InfoMessageImg } from "../../../img/ico-msg-info.svg";
import { ReactComponent as ButtonCloseImg } from "../../../img/btn-close.svg";

import { CustomConfirmBtn } from "../CustomConfirmBtn";
import { CustomCancelBtn } from "../CustomCancelBtn";

import { CustomSquareCheckBox } from "../CustomCheckBox";

import { CustomDropDown, DropdownType } from "../CustomDropdown";
import { useTranslation } from "react-i18next";

const popupModalStyle = {
	content: {
		maxHeight: "100%",
		overflow: "hidden",
		top: "43%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		border: "0px",
		padding: "0px",
		transform: "translate(-50%, -50%)",
		backgroundColor: "transparent",
        zIndex: 13,
		borderRadius: "12px",
	},
    overlay: {
		backgroundColor: "rgba(0, 0, 0, 0.6)"
	},
};

export interface PopupModalItemType {
	id?: string;
	target: string;
	successYn?: boolean;
	reason?: string;
}


export interface PopupModalContentType {
	openYn: boolean;
	type: string;
	title?: string;
	message: string;
	items: PopupModalItemType[];
	code?: string;
	cancelButtonYn: boolean;
	confirmButtonCb?: Function;
	completeYn?: boolean;
	completeTargetText?: string;
	portalMessageYn?: boolean;
	portalMessageTypes?: DropdownType[];
}


interface PopupModalProps {
	showLoadingCb: Function;
	showPopupModalCb: Function;
	content: PopupModalContentType;
}

function PopupModal(props: PopupModalProps){
    const { t } =useTranslation();

	const [topContainerStyle, setTopContainerStyle] = useState(style.topContainer);
	const [closeButtonHoverYn, setCloseButtonHoverYn] = useState(false);
	const [openYn, setOpenYn] = useState(false);
	const [portalMessageType, setPortalMessageType] = useState("");
	const [portalMessageAllTargetYn, setPortalMessageAllTargetYn] = useState(false);
	const [portalMessageTargets, setPortalMessageTargets] = useState<PopupModalItemType[]>([]);
	const [portalMessageTitle, setPortalMessageTitle] = useState("");
	const [portalMessageContent, setPortalMessageContent] = useState("");
	const [portalMessageTitleInputStyle, setPortalMessageTitleInputStyle] = useState(className.portalMessageTitleInput);
	const [portalMessageContentInputStyle, setPortalMessageContentInputStyle] = useState(className.portalMessageContentInput);
	const resultListBody = useRef<null | HTMLDivElement>(null);
	


	useEffect(() => {
		setOpenYn(props.content.openYn);
		if(!props.content.openYn) {
			//init
			setCloseButtonHoverYn(false);
		} else {
			if(props.content.type === POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP) {
				setTopContainerStyle(style.topContainerForComplete);
				resultListBody.current?.scrollIntoView({ behavior: "smooth" })	
			} else if(props.content.type === POPUP_TYPE.PORTAL_MEESAGE_SEND_POPUP) {
				setTopContainerStyle(style.portalMessageTopContainer);
				setPortalMessageTargets(props.content.items);
				
			} else {
				setTopContainerStyle(style.topContainer);
			}
			
		}
	}, [props]);


	

	function closeModal() {
		if(props.content.completeYn === false) {
			return ;
		}
		props.showPopupModalCb(PopupModal.defaultProps);
		setPortalMessageType("");
		setPortalMessageAllTargetYn(false);
		setPortalMessageTargets([]);
		setPortalMessageTitle("");
		setPortalMessageContent("");
		setPortalMessageTitleInputStyle(className.portalMessageTitleInput);
		setPortalMessageContentInputStyle(className.portalMessageContentInput);
	}

	function confirmModal() {
		if(props.content.confirmButtonCb) {
			if(props.content.type !== POPUP_TYPE.PORTAL_MEESAGE_SEND_POPUP) {
				props.content.confirmButtonCb(props.content.code);
			} else {
				props.content.confirmButtonCb(portalMessageAllTargetYn, portalMessageTargets, portalMessageType, portalMessageTitle, portalMessageContent);
			}
		}
		closeModal();
	}

	function selectControlDropdown(code) {
		setPortalMessageType(code);
	}


	function clickPortalMessageTargetDeleteButton(target) {
		let targetList = [...portalMessageTargets];
		let index = targetList.indexOf(target);
		if(index > -1) {
			targetList.splice(index, 1);
			setPortalMessageTargets(targetList);
		}
	}
    return (
        <Modal
		isOpen={props.content.openYn}
		style={popupModalStyle}
		contentLabel={"infoPopup"}
		ariaHideApp={false}
		>
			<View style={topContainerStyle}>
				<CloseButtonImg
							onMouseOver={(e) => {setCloseButtonHoverYn(true);}}
							onMouseOut={(e) => {setCloseButtonHoverYn(false);}}
							onClick={(e) => {closeModal();}}
							style={closeButtonHoverYn ? className.titleCloseButtonImgHover : className.titleCloseButtonImg}/>
				<View style={style.mainContainer}>
					{
						!props.content.portalMessageYn ?
						<Fragment>
							{
								props.content.type === POPUP_TYPE.LIST_MESSAGE_WITH_TITLE_POPUP ||
								props.content.type === POPUP_TYPE.MESSAGE_WITH_TITLE_POPUP ?
								
								<View style={style.titleContainer}>
									<Text style={style.titleText}>{props.content.title}</Text>
								</View>
								: props.content.type === POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP ?
								<View style={style.titleContainerForComplete}>
									<Text style={style.titleTextForComplete}>{props.content.title}</Text>
								</View>
								: null
							}
							{
								props.content.type !== POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP ?
								<View style={style.messageContainer}>
									<Text style={style.messageText}>{props.content.message}</Text>
								</View>
								: 
								<View style={props.content.type === POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP ? style.infoMessageContainerForComplete : style.infoMessageContainer}>
									<InfoMessageImg style={className.infoMessageImg}/>
									<Text style={style.infoMessageText}>{t("TOTAL_PREFIX_TEXT")} {(() => {
										let count = 0;
										for(let idx=0; idx < props.content.items.length; idx++) {
											
											if(props.content.items[idx].successYn) {
												count++;
											}
										}
										return <Text style={style.infoMessageCountText}>{count}</Text>;
									})()} {props.content.message}</Text>
								</View>
							}
							{
								props.content.type === POPUP_TYPE.LIST_MESSAGE_POPUP ||
								props.content.type === POPUP_TYPE.LIST_MESSAGE_WITH_TITLE_POPUP ?
								<View style={style.listContainer}>
									{
										props.content.items.map((item, index) => {
											return (
												<Text style={style.listTargetValue} key={index}>
													{item.target}
												</Text>
											)	
										})
									}
								</View>
								: null
							}
							{
								props.content.type === POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP ?
								<View style={style.resultListContainer}>
									<View style={style.resultListHeaderContainer}>
										<View style={style.resultListRowContainer}>
											<Text style={style.resultListHeaderText}>{props.content.completeTargetText}</Text>
											<Text style={style.resultListHeaderText}>{t("RESULT_TEXT")}</Text>
										</View>
									</View>
									<div ref={resultListBody} style={className.resultListBodyContainer}>
										{
											props.content.items.map((item, index)=> {
												return (
												<View style={style.resultListRowContainer} key={index + 20000}>
													<Text style={style.resultListBodyTargetValue} key={index}>{item.target}</Text>
													<Text numberOfLines={1} style={item.successYn? style.resultListBodyResultValue: style.resultListBodyResultFailValue} key={index + 10000}>{item.successYn? t("SUCCESS_TEXT"): t("FAIL_TEXT")}{item.reason ? " (" + item.reason + ")" : ""}</Text>
												</View>
												)
											})
										}
									</div>
								</View>
								: null
							}
						</Fragment>
					:
					<Fragment>
						<View style={style.portalMessageTitleContainer}>
							<Text style={style.portalMessageTitleText}>{t("PORTAL_MESSAGE_SEND_TEXT")}</Text>
						</View>
						<View style={style.portalMessageMessageTargetContainer}>
							<View style={style.portalMessageRowWrapContainer}>
								<View style={style.portalMessageRowContainer}>
									<Text style={style.portalMessageColumnText}>{t("MESSAGE_TYPE_TEXT")}</Text>
									{/* <ControlDropdown width={114} height={20} items={props.content.portalMessageTypes? props.content.portalMessageTypes : []} selectCb={selectControlDropdown} activeYn={true}/> */}
									<CustomDropDown width={114} height={20} items={props.content.portalMessageTypes? props.content.portalMessageTypes : []} setValue={selectControlDropdown} disable={true}/>
								</View>
							</View>
							<View style={style.portalMessageRowContainer}>
								<Text style={style.portalMessageColumnText}>{t("SEND_TARGET_TEXT")}</Text>
								<CustomSquareCheckBox
									size={20}
									label={t("TOTAL_TEXT")} 
									id={"portalMessageEntireTargetCheckBox"} 
									checked={portalMessageAllTargetYn}
									disabled={true}
									textStyle={{
										fontFamily:"NotoSansKR-Regular",
										fontSize: "12px",
										color: "#333"
									}}
									setCheckBoxStatus={setPortalMessageAllTargetYn}
								/>
							</View>
							<View style={style.portalMessageRowContainer}>
								<Text style={style.portalMessageColumnText}></Text>
								<View style={style.portalMessageTargetListContainer}>
									{
										!portalMessageAllTargetYn ?
										portalMessageTargets.map((item, index) => {
											return (<View style={style.portalMessageTargetListRowContainer} key={index}>
												<Text style={style.portalMessageTargetListBodyTargetValue} key={index+ 10000}>{item.target}</Text>
												<ButtonCloseImg style={className.portalMessageTargetListBodyTargetDeleteImg}
													onClick={(e)=>{clickPortalMessageTargetDeleteButton(item)}}
												/>
											</View>);
										})
										:
										portalMessageTargets.map((item, index) => {
											return (<View style={style.portalMessageTargetListRowContainer} key={index}>
												<Text style={style.portalMessageTargetListBodyTargetValueDisabled} key={index+ 10000}>{item.target}</Text>
											</View>);
										})
									}
								</View>
							</View>
						</View>
						<View style={style.portalMessageContentContainer}>
							<Text style={style.portalMessageContentTitleText}>{t("PORTAL_MESSAGE_SEND_TEXT")}</Text>
							<View style={style.portalMessageContentRowContainer}>
								<Text style={style.portalMessageColumnText}>{t("TITLE_TEXT")}</Text>
								<input type="text"
									maxLength={50}
									placeholder={t("MESSAGE_TITLE_ENTER_MESSAGE")}
									style={portalMessageTitleInputStyle}
									value={portalMessageTitle}
									onChange={(e) => { setPortalMessageTitle(e.target.value); }}
									onFocus={(e) => { setPortalMessageTitleInputStyle(className.portalMessageTitleInputActive);}}
									onBlur={(e) => { setPortalMessageTitleInputStyle(className.portalMessageTitleInput);}}
								/>
							</View>
							<View style={style.portalMessageContentCountContainer}><Text style={style.portalMessageContentCountValue}>{portalMessageTitle.length}</Text><Text style={style.portalMessageContentCountText}> / 50</Text></View>
							<View style={style.portalMessageContentRowContainer}>
								<Text style={style.portalMessageColumnTextareaText}>{t("CONTENT_TEXT")}</Text>
								<textarea
									maxLength={250}
									placeholder={t("MESSAGE_CONTENT_ENTER_MESSAGE")}
									style={portalMessageContentInputStyle}
									value={portalMessageContent}
									onChange={(e) => { setPortalMessageContent(e.target.value); }}
									onFocus={(e) => { setPortalMessageContentInputStyle(className.portalMessageContentInputActive);}}
									onBlur={(e) => { setPortalMessageContentInputStyle(className.portalMessageContentInput);}}
								/>
							</View>
							<View style={style.portalMessageContentCountContainer}><Text style={style.portalMessageContentCountValue}>{portalMessageContent.length}</Text><Text style={style.portalMessageContentCountText}> / 250</Text></View>
						</View>
					</Fragment>
				}
				</View>
				<View style={style.buttonContainer}>
					<View style={style.cancelButtonContainer}>
						{
							//취소 버튼 추가
							openYn && props.content.cancelButtonYn ? <CustomCancelBtn text={t("CANCEL_TEXT")} onPress={closeModal} disabled={false} size={{width: 44, height: 10}}/> : null
						}
					</View>
					<View style={style.confirmButtonContainer}>
						{
							openYn ? <CustomConfirmBtn text={props.content.type === POPUP_TYPE.PORTAL_MEESAGE_SEND_POPUP ? t("SEND_TEXT") : t("CONFIRM_TEXT")} onPress={confirmModal} disabled={props.content.completeYn === false ? true : false} size={{width: 44, height: 10}} /> : null
						}
					</View>
				</View>
			</View>
		</Modal>
    )
}

PopupModal.defaultProps = {
	content: {
		openYn: false,
		message: "",
		items: [],
		cancelButtonYn: false,
		portalMessageYn: false,
	}
};

const style = StyleSheet.create({
	topContainer: {
		width: 400,
		minHeight: 190,
		padding: 20,
		backgroundColor: "#fff"
	},
	topContainerForComplete: {
		width: 700,
		minWidth: 600,
		minHeight: 290,
		padding: 20,
		backgroundColor: "#fff"
	},
	mainContainer: {
		padding: 10,
		alignItems: "center",
		zIndex: 2,
	},
	titleContainer: {
		width: 320,
		marginTop: 12,
		textAlign: "center",
	},
	titleContainerForComplete: {
		width: 630,
		marginTop: 12,
		textAlign: "start"
	},
	titleText: {
		marginTop: 0,
		fontFamily: FONT.MEDIUM,
		fontSize: 15,
		fontWeight: "500",
		color: "#333"
	},
	titleTextForComplete: {
		marginTop: -45,
		fontFamily: FONT.MEDIUM,
		fontSize: 16,
		fontWeight: "500",
		color: "#333"
	},
	messageContainer: {
		width: 320,
		marginTop: 12,
		textAlign: "center"

	},
	messageText: {
		fontFamily: FONT.REGULAR,
		fontSize: 14,
		color: "#333",
	},
	infoMessageContainer: {
		width: 520,
		flexDirection: "row",
	},
	infoMessageContainerForComplete: {
		width: 630,
		flexDirection: "row",
	},
	infoMessageText: {
		marginLeft: 5,
		fontFamily: FONT.REGULAR,
		fontSize: 13,
		color: "#333",
	},
	infoMessageCountText: {
		marginHorizontal: 5,
		fontFamily: FONT.MEDIUM,
		fontSize: 20,
		fontWeight: "500",
		color: "#323ebd",
	},
	listContainer: {
		width: 340,
		height: 137,
		marginTop: 30,
		paddingTop: 19,
		paddingHorizontal: 30,
		overflow: "scroll",
		backgroundColor: "#f2f3f5"
	},
	listTargetValue: {
		marginBottom: 18,
		width: 280
	},
	buttonContainer: {
		flexDirection: "row",
		marginTop: 20,
		marginRight: 20,
		zIndex: 1,
	},
	cancelButtonContainer: {
		marginLeft: "auto",
		marginRight: 10,
	},
	confirmButtonContainer: {
		
	},
	resultListContainer: {
		width: 630,
		height: 154,
		marginTop: 15,
		overflow: "scroll",
		backgroundColor: "#fff",
		borderWidth: 0.8,
		borderColor: "#d2d5d9"
	},
	resultListHeaderContainer: {
		flexDirection: "row",
		borderBottomWidth: 0.8,
		borderBottomColor: "#d2d5d9",
		
	},

	resultListRowContainer: {
		flexDirection: "row",
		paddingVertical: 11,
		paddingHorizontal: 25,
	},
	resultListHeaderText: {
		width: 340,
		fontFamily: FONT.REGULAR,
		fontSize: 12,
		color: "#333",
	},
	resultListBodyTargetValue: {
		width: 340,
		fontFamily: FONT.REGULAR,
		fontSize: 12,
		color: "#333",
	},
	resultListBodyResultValue: {
		fontFamily: FONT.REGULAR,
		fontSize: 12,
		color: "#323ebd",
	},
	resultListBodyResultFailValue: {
		fontFamily: FONT.REGULAR,
		fontSize: 12,
		color: "#db4d30",
		overflow: "hidden"
	},

	portalMessageTopContainer: {
		width: 600,
		minHeight: 700,
		padding: 20,
		backgroundColor: "#fff",
	},
	portalMessageTitleContainer: {
		width: 520,
		marginTop: 12,
		textAlign: "start"
	},
	portalMessageTitleText: {
		marginTop: -45,
		fontFamily: FONT.MEDIUM,
		fontSize: 16,
		fontWeight: "500",
		color: "#333"
	},
	portalMessageMessageTargetContainer: {
		width: 520,
	},
	portalMessageRowWrapContainer: {
		zIndex: 15,
	},
	portalMessageRowContainer: {
		flexDirection: "row",
		alignItems: "center",
		marginBottom: 30,
	},
	portalMessageColumnText: {
		width: 150,
		fontFamily: FONT.REGULAR,
		fontSize: 13,
		color: "#333",
	},
	portalMessageColumnTextareaText: {
		width: 150,
		marginTop: -80,
		fontFamily: FONT.REGULAR,
		fontSize: 13,
		color: "#333",
	},
	portalMessageTargetListContainer: {
		width: 360,
		height: 145,
		paddingTop: 13,
		paddingLeft: 25,
		paddingRight: 5,
		backgroundColor: "#f2f3f5",
		overflow: "scroll",
		
	},
	portalMessageTargetListRowContainer: {
		flexDirection: "row",
		marginBottom: 13,
	},
	portalMessageTargetListBodyTargetValue: {
		height: 20,
		fontFamily: FONT.REGULAR,
		fontSize: 12,
		color: "#0853fb"
	},
	portalMessageTargetListBodyTargetValueDisabled: {
		height: 20,
		fontFamily: FONT.REGULAR,
		fontSize: 12,
		color: "#333"
	},

	portalMessageContentContainer: {
		width: 600,
		height: 300,
		paddingTop: 30,
		paddingLeft: 40,
		backgroundColor: "#edf0f5"
	},
	portalMessageContentRowContainer: {
		flexDirection: "row",
		alignItems: "center",
	},
	portalMessageContentTitleText: {
		fontFamily: FONT.MEDIUM,
		fontSize: 14,
		color: "#0853fb",
		marginBottom: 30,
	},
	portalMessageContentCountContainer: {
		flexDirection: "row",
		justifyContent: "flex-end",
		marginTop: 2,
		marginBottom: 17,
		marginRight: 48
	},
	portalMessageContentCountValue: {
		fontFamily: FONT.MEDIUM,
		fontSize: 11,
		color: "#7b7d80"
		
	},
	portalMessageContentCountText: {
		fontFamily: FONT.MEDIUM,
		fontSize: 11,
		color: "#b9bcbf"
	}
	
});

const className = {
	infoMessageImg: {
		marginTop: 7,
	},
	titleCloseButtonImg: {
		width: "28px",
		height: "28px",
		marginLeft: "auto",
		boxShadow: "none",
		cursor: "pointer"
	},
	titleCloseButtonImgHover: {
		width: "28px",
		height: "28px",
		marginLeft: "auto",
		boxShadow: "none",
		cursor: "pointer"
	},
	resultListBodyContainer: {
		height: 137,
		overflow: "scroll",
	},
	portalMessageTargetListBodyTargetDeleteImg: {
		marginLeft: "auto",
		cursor: "pointer"
	},
	portalMessageTitleInputActive: {
        width: "349px",
        height: "33px",
        paddingLeft: "11px",
        border: "solid 0.8px rgba(99, 122, 255, 0.8)",
        borderRadius: "4px",
        outline: "none",
        fontFamily: FONT.REGULAR,
        fontSize: "13px",
        lineHeight: "0.92",
        backgroundColor: "#fff"
	},
	portalMessageTitleInput: {
        width: "349px",
        height: "33px",
        paddingLeft: "11px",
        border: "solid 0.8px #d2d5d9",
        borderRadius: "4px",
        outline: "none",
        fontFamily: FONT.REGULAR,
        fontSize: "13px",
        lineHeight: "0.92",
        backgroundColor: "#fff"
	},
	portalMessageContentInputActive: {
        width: "349px",
        height: "97px",
		paddingTop: "10px",
        paddingLeft: "11px",
        border: "solid 0.8px rgba(99, 122, 255, 0.8)",
        borderRadius: "4px",
        outline: "none",
        fontFamily: FONT.REGULAR,
        fontSize: "13px",
        lineHeight: "0.92",
        backgroundColor: "#fff",
		resize: "none"
	} as CSSProperties,
	portalMessageContentInput: {
		width: "349px",
        height: "97px",
		paddingTop: "10px",
        paddingLeft: "11px",
        border: "solid 0.8px #d2d5d9",
        borderRadius: "4px",
        outline: "none",
        fontFamily: FONT.REGULAR,
        fontSize: "13px",
        lineHeight: "0.92",
        backgroundColor: "#fff",
		resize: "none"
	} as CSSProperties,
}
export default PopupModal;